import { render, staticRenderFns } from "./ConfigList.vue?vue&type=template&id=0214f132&scoped=true"
import script from "./ConfigList.vue?vue&type=script&lang=js"
export * from "./ConfigList.vue?vue&type=script&lang=js"
import style0 from "./ConfigList.vue?vue&type=style&index=0&id=0214f132&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0214f132",
  null
  
)

export default component.exports